const LANG_TO_COUNTRY = {
  en: 'gb',
  fr: 'fr',
  de: 'de',
  es: 'es',
  it: 'it',
  pt: 'pt',
  nl: 'nl',
  ja: 'jp',
  ko: 'kr',
  zh_Hans: 'cn',
  zh_Hant: 'cn',
}

export const LANG_ISO = {
  de: 'de-DE',
  en: 'en-GB',
  fr: 'fr-FR',
  es: 'es-ES',
  it: 'it-IT',
  pt: 'pt-PT',
  nl: 'nl-NL',
  ja: 'ja-JP',
  ko: 'ko-KR',
  zh_Hans: 'zh-Hans-CN',
  zh_Hant: 'zh-Hant-TW',
}

export const LANG_SCRIPT_LABEL = {
  zh_Hans: '简',
  zh_Hant: '繁',
}

export const langToCountry = lang => LANG_TO_COUNTRY[lang] || lang

export const langToFlagpackCode = lang => (lang === 'en' ? 'GBR' : langToCountry(lang).toUpperCase())

export const toLanguageTag = lang => lang.replace('_', '-')
